<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header :content="'活动配置'+( id > 0 ? '编辑':'新增')" @back="goBack" /></span>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules" label-width="120px" class="demo-ruleForm">
          <el-row>
            <el-form-item style="display: inline-block" label="活动名称">
              <el-input v-model="formData.name" style="width: 200px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="活动类型">
              <el-select v-model.number="formData.uc_type" placeholder="请选择" style="width: 200px" @change="ucTypeChange">
                <el-option v-for="item in ucType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="活动分类">
              <el-select v-model="formData.type" filterable :disabled="id > 0" placeholder="请选择" style="width: 200px" @change="typeChange">
                <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="活动皮肤">
              <el-select v-model="formData.imgName" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in coupon_skin" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="活动状态" prop="is_online">
              <el-select v-model.number="formData.is_online" disabled placeholder="请选择" style="width: 200px">
                <el-option v-for="item in actType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="开始时间">
              <el-date-picker v-model="formData.start_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="开始时间" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="结束时间">
              <el-date-picker v-model="formData.end_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" placeholder="结束时间" />
            </el-form-item>
            <el-form-item v-if="formData.type !== 'rank'" style="display: inline-block" label="领奖时间" prop="reward_time">
              <el-date-picker v-model.trim="formData.reward_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 200px" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="多语言KEY" prop="show_title">
              <el-input v-model="formData.show_title" style="width: 520px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="优先级" prop="priority">
              <el-input v-model.number="formData.priority" style="width: 520px" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="客户端类型" prop="client">
              <el-select v-model.number="formData.is_show_b" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in clientType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="游客类型" prop="user_type">
              <el-select v-model.number="formData.user_type" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in clientType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="参与等级(Min)">
              <el-input v-model.number="formData.user_level_min" style="width: 200px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="参与等级(Max)">
              <el-input v-model.number="formData.user_level_max" style="width: 200px" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="vip等级(min)">
              <el-input v-model="formData.user_vip_min" style="width: 200px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="vip等级(max)">
              <el-input v-model="formData.user_vip_max" style="width: 200px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="vip分数(min)">
              <el-input v-model="formData.user_score_min" style="width: 200px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="vip分数(max)">
              <el-input v-model="formData.user_score_max" style="width: 200px" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="是否显示按钮" prop="is_show_b">
              <el-select v-model.number="formData.is_show_b" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in isShowB" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.is_show_b === 1" style="display: inline-block" label="按钮多语言KEY" prop="bname">
              <el-input v-model="formData.bname" style="width: 520px" />
            </el-form-item>
            <el-row>
              <el-form-item v-if="formData.is_show_b === 1" style="display: inline-block" label="按钮颜色" prop="bcolor">
                <el-select v-model.number="formData.bcolor" placeholder="请选择" style="width: 200px">
                  <el-option v-for="item in bcolorType" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="formData.is_show_b === 1" style="display: inline-block" label="按钮跳转位置" prop="bskip">
                <el-input v-model.number="formData.bskip" style="width: 200px" />
              </el-form-item>
              <el-form-item v-if="formData.is_show_b === 1" style="display: inline-block" label="按钮跳转地址" prop="burl">
                <el-input v-model="formData.burl" style="width: 200px" />
              </el-form-item>
            </el-row>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="循环类型">
              <el-select v-model.number="formData.loop_type" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in loopType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="循环周期" prop="loop_num">
              <el-input v-model.number="formData.loop_num" style="width: 200px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="循环生效时间" prop="loopTime">
              <el-input v-model.number="formData.loopTime" style="width: 200px" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="向下兼容版本" prop="isComVersion">
              <el-select v-model.number="formData.isComVersion" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in isComVersionType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="版本控制" prop="act_version">
              <el-select v-model="formData.act_version" multiple placeholder="请选择" style="width: 520px">
                <el-option v-for="item in versionData" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="用户白名单" prop="act_version">
              <el-select v-model="formData.user_uid_section" multiple filterable remote reserve-keyword placeholder="请输入用户ID" :remote-method="remoteMethod" :loading="loading" style="width: 520px">
                <el-option v-for="item in users" :key="item.uid" :label="item.uid" :value="item.uid" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="ABTest键" prop="act_version">
              <el-input v-model.number="formData.abTestKey" style="width: 520px" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item style="display: inline-block" label="活动参与人数" prop="joinNum">
              <el-input v-model.number="formData.joinNum" style="width: 200px" />
            </el-form-item>
            <el-form-item style="display: inline-block" label="是否弹窗" prop="isPopUp">
              <el-select v-model.number="formData.isPopUp" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in openPushType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="是否推送" prop="openPush">
              <el-select v-model.number="formData.openPush" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in openPushType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item style="display: inline-block" label="是否为隐藏" prop="ishide">
              <el-select v-model.number="formData.ishide" placeholder="请选择" style="width: 200px">
                <el-option v-for="item in openPushType" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item v-if="collectType.includes(formData.type)" label="收集物配置" prop="reward_conf" style="width: 960px">
              <el-card>
                <el-form :inline="true">
                  <el-form-item label="分组" style="margin-top: 5px" prop="steal_break">
                    <el-select v-model.number="formData.reward_conf.groupId" placeholder="请选择" @change="groupChange">
                      <el-option v-for="item in groupType" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled" />
                    </el-select>
                  </el-form-item>
                  <el-form-item v-if="numShow" label="收集物数量" style="margin-top: 5px" prop="steal_break">
                    <el-input v-model.number="formData.reward_conf.num" style="width: 200px" />
                  </el-form-item>
                </el-form>
                <el-form :inline="true">
                  <el-row v-for="(item, i) in formData.reward_conf.collect" :key="i">
                    <el-form-item label="类型" style="margin-top: 5px;" prop="steal_break">
                      <el-select v-model="item.type" placeholder="请选择类型" @change="(v)=>{ return selectTypeChange(v)}">
                        <el-option v-for="(item, index) in selectType" :key="index" :disabled="item.disabled" :label="item.title" :value="item.id" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="倍数" style="margin-top: 5px" prop="steal_break">
                      <el-input v-model.number="item.bet" style="width: 200px" />
                    </el-form-item>
                    <el-form-item style="margin-top: 5px">
                      <el-button type="danger" @click="delCollect(i)">删除</el-button>
                    </el-form-item>
                  </el-row>
                </el-form>
                <el-button style="margin-top: 5px" type="primary" @click="addCollect">+</el-button>
              </el-card>
            </el-form-item>
          </el-row>
          <el-form-item style="width:100%;margin-top:50px;text-align: center">
            <el-button :disabled="isOnline ===1" type="primary" @click="submitForm('formData')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>
import {
  // getActivityImgList,
  getActivityList,
  getActivityTypesList,
  getCollectTypesList, getStealAttackTYpesList,
  updateActivityCfg
} from '@/api/config/activity-cfg'
import { getVersionCfg } from '@/api/config/version-set'
import { getToken } from '@/utils/auth'
import { getActiveSkinTypeList } from '@/api/config/active-skin-cfg'
import { getCacheConfig } from '@/utils'
import { searchUid } from '@/api/user/user_info'
export default {
  name: 'ActivityConfigEdit',
  data() {
    return {
      users: [],
      loading: false,
      isOnline: 0,
      drawer: false,
      isRule: 0,
      fileList: { 'entry': {}, 'prop': {}, 'title': {}, 'pop': {}},
      fileList1: [{ name: 'a', url: 'http://testcdn.aibase.cc/build_pack/4152/de.png' }],
      dialogImageUrl: '',
      dialogVisible: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      id: 0,
      types: [],
      randTypes: ['rank', 'rank2'],
      actType: [{ label: '上线', value: 1 }, { label: '下线', value: 0 }],
      isShowB: [{ label: '显示', value: 1 }, { label: '隐藏', value: 0 }],
      clientType: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: 'IOS', value: 2 }],
      userType: [{ label: '全部', value: 0 }, { label: 'FB', value: 1 }, { label: '游客', value: 2 }],
      loopType: [{ label: '单次', value: 1 }, { label: '小时', value: 2 }, { label: '天', value: 3 }],
      ucType: [{ label: '常规活动', value: 0 }, { label: '道具型活动', value: 1 }],
      abTestType: [{ label: '默认', value: 0 }, { label: 'A组', value: 1 }, { label: 'B组', value: 2 }],
      openPushType: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      isComVersionType: [{ label: '是', value: 0 }, { label: '否', value: 1 }],
      abType: [{ label: '关闭', value: 0 }, { label: 'firebase', value: 1 }, { label: '数数分群', value: 2 }],
      bcolorType: [
        { label: '蓝色', value: 1 },
        { label: '红色', value: 2 },
        { label: '绿色', value: 3 },
        { label: '灰色', value: 4 },
        { label: '橙色', value: 5 }
      ],
      versionData: [],
      coupon_skin: [
        { label: '默认', value: 'default' }
        // { label: '披萨', value: '1' }
      ],
      formData: {
        'Id': 0,
        'cid': '',
        'name': '',
        'name_en': '',
        'start_time': '',
        'end_time': '',
        'start': '',
        'end': '',
        'is_online': 0,
        'show_title': '',
        'status': 0,
        'is_show_b': 0,
        'bname': '',
        'bcolor': 0,
        'bskip': 0,
        'burl': '',
        'img': '',
        'imgName': 'default',
        'act_coupon_skin': '0',
        'lock_time': '',
        'textColor': '',
        'reward_time': '',
        'client': 0,
        'user_type': 0,
        'user_level_section': '-',
        'user_level_min': 0,
        'user_level_max': 0,
        'user_vip_section': '-',
        'user_vip_min': 0,
        'user_vip_max': 0,
        'user_score_section': '-',
        'user_score_min': 0,
        'user_score_max': 0,
        'loop_type': 1,
        'loop_num': 0,
        loopTime: 0,
        'reward_conf': {
          groupId: 1,
          num: 0,
          collect: []
        },
        'reward_pro': [{ k: 1, v: 1 }],
        'uc_type': 0,
        'act_version': [],
        'abTest': 0,
        'openPush': 0,
        'joinNum': 0,
        'country': 0,
        'isComVersion': 0,
        'isPopUp': 0,
        'abType': 0,
        'taTest': 0,
        'priority': 0,
        'ishide': 0,
        'is_rule': 0,
        extraData: {
          isShowSpine: 0,
          open: 0,
          ts: [
            { s: '', e: '' },
            { s: '', e: '' }
          ]
        }
      },
      actImg: {
        entry: { en: '', zh: '', tw: '', de: '', th: '', fr: '' },
        prop: { en: '', zh: '', tw: '', de: '', th: '', fr: '' },
        title: { en: '', zh: '', tw: '', de: '', th: '', fr: '' },
        pop: { en: '', zh: '', tw: '', de: '', th: '', fr: '' }
      },
      rules: {
      },
      groupType: [
        { label: '常规收集', value: 1, disabled: false },
        { label: '特殊收集', value: 2, disabled: false },
        { label: '特殊收集偷', value: 3, disabled: false },
        { label: '特殊收集打', value: 4, disabled: false },
        { label: '偷', value: 5, disabled: false },
        { label: '打', value: 6, disabled: false },
        { label: '特殊收集+偷+打', value: 7, disabled: false },
        { label: '收集偷', value: 8, disabled: false },
        { label: '收集打', value: 9, disabled: false },
        { label: '偷打', value: 10, disabled: false } // 竞标赛
      ],
      // formData.type === 'super_collect' || formData.type === 'super_collect2'

      collectType: ['super_collect', 'super_collect2', 'super_collect3', 'rank', 'rank2', 'club_rank'],
      numShow: false,
      selectType: [],
      exactArr: [6, 7, 8, 9, 10, 11, 12],
      tempStealType: []
    }
  },
  created() {
    this.getVersion()
    this.getActivityTypes()
    this.getActCollectTypes()
    // this.getActStealAttackTypes()
    const id = this.$route.query.id
    const rule = parseInt(this.$route.query.rule)
    this.isOnline = parseInt(this.$route.query.is_online)
    this.id = id
    if (id > 0) {
      this.getTables(id)
    }
    if (rule > 0 && id <= 0) {
      this.isRule = rule
      this.formData.imgName = []
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    getVersion() {
      getVersionCfg().then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.versionData.push({ label: item, value: item })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    selectTypeChange(v, $event) {
      this.selectType.forEach((item, index) => {
        if (item.id === v) {
          this.selectType[index].disabled = true
        }
      })
      this.listenChangeType()
    },
    addCollect() {
      this.listenChangeType()
      let selectVal = ''
      const selectType = this.selectType

      for (const i in selectType) {
        if (!selectType[i].disabled) {
          selectVal = selectType[i].id
          this.selectType[i].disabled = true
          break
        }
      }

      if (!selectVal) {
        this.msgError('没有可选的类型')
        return
      }

      this.formData.reward_conf.collect.push({
        type: selectVal,
        bet: 0
      })
      this.listenChangeType()
    },
    listenChangeType() {
      // console.log('listenChangeType')
      const collect = this.formData.reward_conf.collect
      this.numShow = false
      for (const index in this.selectType) {
        this.selectType[index].disabled = false
        for (const i in collect) {
          if (collect[i].type === this.selectType[index].id && !this.selectType[index].disabled) {
            this.selectType[index].disabled = true
            if (this.formData.reward_conf.groupId !== 10 && this.selectType[index].id === 5 && !this.numShow) {
              this.numShow = true
            }
            break
          }
        }
      }
    },
    delCollect(i) {
      this.formData.reward_conf.collect = this.formData.reward_conf.collect.filter((item, index) => {
        return i !== index
      })
      this.listenChangeType()
    },
    getActStealAttackTypes() {
      this.selectType = []
      this.tempStealType = []
      getStealAttackTYpesList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.tempStealType.push(parseInt(i))
            this.selectType.push({ 'title': res.data[i], 'id': parseInt(i), disabled: false })
          }

          // 清理
          const newCollect = []
          for (const i in this.formData.reward_conf.collect) {
            const val = this.formData.reward_conf.collect[i]
            if (this.tempStealType.includes(val.type)) {
              newCollect.push(val)
            }
          }

          this.formData.reward_conf.collect = newCollect
          this.listenChangeType()
        }
      })
    },
    getActCollectTypes() {
      this.selectType = []
      getCacheConfig(getCollectTypesList, 'getCollectTypesList', {}).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.selectType.push({ 'title': res.data[i], 'id': parseInt(i), disabled: false })
          }

          this.listenChangeType()
        }
      })
    },
    getTables(id) {
      getActivityList({ id: id }).then(res => {
        if (res.code === 200) {
          // for (const k in res.data.list[0]) {
          //   this.formData[k] = res.data.list[0][k]
          // }
          this.formData = res.data.list[0]
          this.isRule = this.formData.uc_type
          const [level_min, level_max] = this.formData.user_level_section.split('-')
          this.$set(this.formData, 'user_level_min', parseInt(level_min))
          this.$set(this.formData, 'user_level_max', parseInt(level_max))

          const [score_min, score_max] = this.formData.user_score_section.split('-')
          this.$set(this.formData, 'user_score_min', parseInt(score_min))
          this.$set(this.formData, 'user_score_max', parseInt(score_max))

          const [vip_min, vip_max] = this.formData.user_vip_section.split('-')
          this.$set(this.formData, 'user_vip_min', parseInt(vip_min))
          this.$set(this.formData, 'user_vip_max', parseInt(vip_max))
          const collect = this.formData.reward_conf.collect
          const newCollect = []
          this.numShow = false
          for (const k in collect) {
            const _type = parseInt(k)
            if (!this.exactArr.includes(_type)) {
              newCollect.push({ type: _type, bet: collect[k] })
            }
          }
          if (this.collectType.includes(this.formData.type)) {
            this.formData.reward_conf.groupId = parseInt(this.formData.reward_conf.groupId)
            this.$set(this.formData.reward_conf, 'collect', newCollect)
          }

          if (this.formData.act_version === null) {
            this.formData.act_version = []
          }

          if (this.collectType.includes(this.formData.type)) {
            if (this.formData.extraData.ts === '{}') {
              this.formData.extraData.ts = []
            } else {
              const tsTemp = []
              for (const i in this.formData.extraData.ts) {
                const val = this.formData.extraData.ts[i]
                tsTemp.push(val)
              }
              this.formData.extraData.ts = tsTemp
            }
          }
          this.groupChange(this.formData.reward_conf.groupId)
          this.changeGroupType()
          this.listenChangeType()
          this.getActSkinTypeList(this.formData.type)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    changeGroupType() {
      this.groupType.forEach((item, index) => {
        if (item.value === 10 && !this.randTypes.includes(this.formData.type)) {
          this.groupType[index].disabled = true
        }
      })
    },
    submitForm() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const formData = this.formData
          // console.log(this.formData)
          if (!formData.name) {
            this.msgError('活动名称不能为空')
            return
          }
          if (!formData.type) {
            this.msgError('请选择活动模板')
            return
          }

          if (!formData.start_time) {
            this.msgError('请选择开始时间')
            return
          }
          if (!formData.end_time) {
            this.msgError('请选择结束时间')
            return
          }

          if (formData.start_time > formData.end_time) {
            this.msgError('开始时间不能大于结束时间')
            return
          }
          if (['rank', 'club_rank'].includes(formData.type)) {
            formData.reward_time = formData.end_time
          }
          if (!formData.reward_time) {
            this.msgError('请选择领奖时间')
            return
          }
          if (formData.show_title === '') {
            this.msgError('标题名称不能为空')
            return
          }
          if (formData.user_level_min > formData.user_level_max) {
            this.msgError('参与等级范围-最小等级不能大于最大等级')
            return
          }

          if (formData.user_vip_min > formData.user_vip_max) {
            this.msgError('vip等级区间-最小等级不能大于最大等级')
            return
          }
          if (formData.user_score_min > formData.user_score_max) {
            this.msgError('vip分数区间-最小分数不能大于最大分数')
            return
          }
          if (formData.loop_num === '') {
            this.msgError('请输入循环周期')
            return
          }

          if (formData.imgName === '') {
            this.msgError('请输入资源所在位置目录名')
            return
          }
          if (formData.joinNum === '') {
            this.msgError('请输入参与人数')
            return
          }

          if (formData.imgName === 'default' && formData.type === 'run_for_it') {
            this.msgError('搭桥快跑不能配置默认皮肤')
            return
          }

          if (this.collectType.includes(formData.type)) {
            const newTs = {}
            let num = 1
            for (const i in formData.extraData.ts) {
              const val = formData.extraData.ts[i]
              if (val.s > val.e) {
                this.msgError('限时-开始时间不能大于结束时间')
                return
              }

              newTs[num] = val
              num++
            }

            this.formData.extraData.ts = newTs
          }

          const newActVersion = []
          for (const i in formData.act_version) {
            const val = formData.act_version[i]
            if (val !== '') {
              newActVersion.push(val)
            }
          }
          this.formData.is_rule = this.isRule
          this.formData.act_version = newActVersion
          this.formData.user_level_section = formData.user_level_min + '-' + formData.user_level_max
          this.formData.user_vip_section = formData.user_vip_min + '-' + formData.user_vip_max
          this.formData.user_score_section = formData.user_score_min + '-' + formData.user_score_max
          for (const k in this.formData) {
            const val = this.formData[k]
            if (k === 'reward_pro') {
              for (const k in val) {
                const _data = val[k]
                if (_data.bet === '') {
                  this.msgError('倍数不能为空')
                  return
                }
              }
            }
          }

          const newFormData = this.formData
          if (this.collectType.includes(formData.type)) {
            const groupId = newFormData.reward_conf.groupId
            const collect = newFormData.reward_conf.collect
            if (collect.length <= 0) {
              this.msgError('奖励进度获取配置未配置')
              return
            }
            const num = newFormData.reward_conf.num
            const newCollect = { num: num, groupId: groupId, collect: {}}
            let selectNumBet = 0
            for (const i in collect) {
              const _collect = collect[i]
              newCollect.collect[_collect.type] = _collect.bet
              if (_collect.type === 5) {
                selectNumBet = _collect.bet
              }
            }
            // 加入金币
            if (this.numShow) {
              for (let i = 6; i <= 12; i++) {
                newCollect.collect[i] = selectNumBet
              }
            }
            // console.log('newCollect', newCollect)
            newFormData.reward_conf = newCollect
          }

          const data = JSON.stringify(newFormData)
          this.actImg.aid = this.id
          const actImg = JSON.stringify(this.actImg)
          console.log('data', data)
          updateActivityCfg({ type: this.formData.type, data: data, name: actImg }).then(res => {
            if (res.code === 200) {
              this.msgSuccess(res.msg)
              this.$store.dispatch('app/clearLocalStorage', { key: 'getPropsActList' })
              this.$router.push({ path: '/config/activity-config/index' })
              this.$nextTick(() => {
                this.$root.$emit('fetchData') // 发送事件通知列表页更新数据
              })
              // if (this.isRule > 0) {
              //   this.$router.push({ path: '/config/activity-config/rule' })
              //   this.$nextTick(() => {
              //     this.$root.$emit('fetchRuleData') // 发送事件通知列表页更新数据
              //   })
              // } else {
              //   this.$router.push({ path: '/config/activity-config/index' })
              //   this.$nextTick(() => {
              //     this.$root.$emit('fetchData') // 发送事件通知列表页更新数据
              //   })
              // }
            } else {
              this.msgError(res.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getActivityTypes() {
      getCacheConfig(getActivityTypesList, 'getActivityTypesList', {}).then(res => {
        for (const i in res.data) {
          const val = res.data[i]
          this.types.push({ label: val, value: i })
        }
      })
    },
    delRewardPro(k) {
      this.formData.reward_pro = this.formData.reward_pro.filter((res, i) => {
        return k !== i
      })

      let count = 0
      this.formData.reward_pro.forEach((item, index) => {
        count++
        this.formData.reward_pro[index].k = count
      })
    },
    addRewardPro() {
      const len = this.formData.reward_pro.length
      this.formData.reward_pro.push({
        k: len + 1,
        v: 0
      })
    },
    handleRemove(file, tag, key) {
      this.actImg[tag][key] = ''
      delete this.fileList[tag][key]
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'

      if (!isJPG && !isPNG) {
        this.$message.error('图片只能是 JPG/PNG 格式!')
        return false
      }
      return true
    }, uploadSuccess(file, tag, key, i) {
      this.$set(this.fileList[tag], key, { name: file.data.name, url: file.data.path })
      this.actImg[tag][key] = file.data.path
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    addTs() {
      this.formData.extraData.ts.push({ s: '', e: '' })
    },
    delTs(i) {
      this.formData.extraData.ts = this.formData.extraData.ts.filter((res, index) => {
        return i !== index
      })
    },
    typeChange(v) {
      if (this.collectType.includes(v)) {
        this.formData.extraData = {
          isShowSpine: 0,
          open: 0,
          ts: []
        }
      } else {
        if (v === 'golden_card_trade') {
          this.formData.extraData = []
        } else {
          this.formData.extraData = {}
        }

        this.formData.reward_conf = {}
      }

      this.getActSkinTypeList(v)
    },
    getActSkinTypeList(typ) {
      this.coupon_skin = []
      getActiveSkinTypeList({ name: typ }).then(res => {
        this.coupon_skin.push({ label: '默认', value: 'default' })
        if (res.code === 200) {
          res.data.forEach(item => {
            this.coupon_skin.push({ label: item.name, value: item.value })
          })
          if (this.id <= 0 && this.coupon_skin.length > 1) {
            this.formData.imgName = this.coupon_skin[1].value
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    groupChange(v) {
      if (this.randTypes.includes(this.formData.type) && v === 10) {
        this.getActStealAttackTypes()
      } else {
        this.getActCollectTypes()
      }
    },
    ucTypeChange(v) {
      if (v === 1) {
        this.formData.imgName = []
      } else {
        this.formData.imgName = ''
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        searchUid({ id: query, version: '1' }).then(res => {
          this.loading = false
          this.users = res.data.data
        })
      } else {
        this.users = []
      }
    }
  }
}
</script>

<style scoped>
.hide_box /deep/ .el-upload--picture-card {
  display: none;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>
